import { render } from "./SearchAutoDialog.vue?vue&type=template&id=120349b2&scoped=true"
import script from "./SearchAutoDialog.vue?vue&type=script&lang=js"
export * from "./SearchAutoDialog.vue?vue&type=script&lang=js"

import "./SearchAutoDialog.vue?vue&type=style&index=0&id=120349b2&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120349b2"]])

export default __exports__